var Plotly = require("plotly.js/lib/core");

// Load in the trace types required
Plotly.register([
  require("plotly.js/lib/pie"),
  require("plotly.js/lib/choropleth"),
]);

module.exports = Plotly;
